import { mapState } from 'vuex';
import axios from 'axios';

export const apiCalls = {
			data() {
				return {
                    apiErrors: false,
                    apiErrorMessages: []
                };
			},
			computed: {
				...mapState(['host', 'root', 'session', 'loading']),
			},
			methods: {
				async getApi(url) {
					this.$store.commit('TOGGLE_OVERLAY', true);
					const response = await axios.get(`${this.root}/laravel/public${url}`).catch(
						function(error) {
							const status = error.response.status;
							switch (status) {
								case 401:
									window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
									this.$store.commit('TOGGLE_OVERLAY', false)
									break;
								default: 
									this.$store.commit('TOGGLE_OVERLAY', false)
									break;
							}
						}.bind(this)
					);
					this.$store.commit('TOGGLE_OVERLAY', false)

					return response ? response.data : response;
				},
				async postApi(url, data) {
					let axiosConfig = {
						headers: {
							'Content-Type': 'application/json;charset=UTF-8',
							'Access-Control-Allow-Origin': '*',
						},
					};

					const response = await axios.post(`${this.root}/laravel/public${url}`, data, axiosConfig).catch(
						function(error) {
							const status = error.response.status;
							
							switch (status) {
								case 401:
									window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
									break;
								default:
									this.apiErrors = true;
									this.apiErrorMessages = error.response.data;
									break;
							}
						}.bind(this)
					);
					return response ? response.data : ( this.apiErrors ? { error: this.apiErrorMessages } : response);
				},
				async putApi(url, data) {
					const response = await axios.put(`${this.root}/laravel/public${url}`, data).catch(
						function(error) {
							const status = error.response.status;
							
							switch (status) {
								case 401:
									window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
									break;
								case 400:
									this.apiErrors = true;
									this.apiErrorMessages = error.response.data;
									break;
								case 404:
									this.apiErrors = true;
									this.apiErrorMessages = 'Not Found';
									break;
								case 409:
									this.apiErrors = true;
									this.apiErrorMessages = error.response.data[0].message;
									break;
								case 418:
									this.apiErrors = true;
									this.apiErrorMessages = error.response.data;
									break;
							}
						}.bind(this)
					);
					
					if(response && response.data != undefined){
						return response.data;
					}else if(response){
						return response;
					} else if(this.apiErrors) {
						return (
							typeof this.apiErrorMessages.error != 'undefined' && this.apiErrorMessages.error != null &&
							this.apiErrorMessages.error != "" && this.apiErrorMessages.error != []
						) ? this.apiErrorMessages : { error: this.apiErrorMessages };
					}
				},
				async patchApi(url, data) {
					const response = await axios.patch(`${this.root}/laravel/public${url}`, data).catch(
						function(error) {
							const status = error.response.status;

							switch (status) {
								case 401:
									window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
									break;
							}
						}.bind(this)
					);

					return response ? response.data : response;
				},
				async deleteApi(url, data) {
					const response = await axios.delete(`${this.root}/laravel/public${url}`, { data: data }).catch(
						function(error) {
							const status = error.response.status;
							
							switch (status) {
								case 401:
									window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
									break;
							}
						}.bind(this)
					);

					return response ? response.data : response;
				},
				async api(method, url, data = {}) {
					let config = {};

					// `baseURL` will be prepended to `url` unless `url` is absolute.
					// It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
					// to methods of that instance.
					//baseURL: 'https://some-domain.com/api/',

					// `method` is the request method to be used when making the request
					config.method = method;

					// `url` is the server URL that will be used for the request
					config.url = `${this.root}/laravel/public${url}`;

					// `data` is the data to be sent as the request body
					// Only applicable for request methods 'PUT', 'POST', and 'PATCH'
					// When no `transformRequest` is set, must be of one of the following types:
					// - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
					// - Browser only: FormData, File, Blob
					// - Node only: Stream, Buffer
					config.data = data;

					// `timeout` specifies the number of milliseconds before the request times out.
					// If the request takes longer than `timeout`, the request will be aborted.
					//timeout: 1000, // default is `0` (no timeout)
					this.apiErrors = false;
					this.$store.commit('TOGGLE_OVERLAY', true)

					const response = await axios.request(config).catch(
						function(error) {		
							this.$store.commit('TOGGLE_OVERLAY', false)
							let status = false;
							
							try {
								status = error.response.status;
							} catch(error) {
								//status 405 will go here
								//return undefined;
							}
							switch (status) {
								case 401:
									window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
									break;

								case 400:
									this.apiErrors = true;
									this.apiErrorMessages = error.response.data;
									break;

								case 404:
									this.apiErrors = true;
									this.apiErrorMessages = 'Not Found';
									break;

								case 409:
									this.apiErrors = true;
									this.apiErrorMessages = error.response.data[0].message;
									break;

								case 418:
									this.apiErrors = true;
									this.apiErrorMessages = error.response.data;
									break;
							}

						}.bind(this)
					);
					
					if(response && response.data != undefined){
						this.$store.commit('TOGGLE_OVERLAY', false)
						return response.data;
					}else if(response){
						this.$store.commit('TOGGLE_OVERLAY', false)
						return response;
					} else if(this.apiErrors) {
						this.$store.commit('TOGGLE_OVERLAY', false)
						return (
							typeof this.apiErrorMessages.error != 'undefined' && this.apiErrorMessages.error != null &&
							this.apiErrorMessages.error != "" && this.apiErrorMessages.error != []
						) ? this.apiErrorMessages : { error: this.apiErrorMessages };
					}

					this.$store.commit('TOGGLE_OVERLAY', false)
				},
			},
		};